var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[_c('vx-tooltip',{attrs:{"color":"primary","text":"Edit Alarm","position":"left"}},[_c('vs-button',{attrs:{"color":"primary","type":"flat","icon-pack":"feather","icon":"icon-settings"},on:{"click":function($event){return _vm.open()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }